import HMS from '../images/HMS.png';
import TBS from '../images/TBS.png';
import FR from '../images/FR.png';
import pcps from '../images/pcps.jpg';
import kmc from '../images/kmc.jpg';
import bagmati from '../images/bagmati.png';
import TK from '../images/TK.png';
import CA from '../images/CA.png';

export const Bio = {
    name: "Aanik Khapangi Magar",
    roles: [
      "Student",
      "Programmer",
    ],
    description:
    "driven by boundless curiosity and relentless determination. With a knack for versatility and punctuality, I'm all about diving headfirst into the exhilarating world of coding. Let's embark on this exciting journey together, where innovation knows no bounds!",
    github: "https://github.com/Aanik-2003",
    resume:
      "https://drive.google.com/file/d/1VPtbEk3kaKDb90hCNGx8L2eNg305xXBn/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/aanik-magar-550145243/",
    insta: "https://www.instagram.com/aanik_magar9/",
    facebook: "https://www.facebook.com/aanik.magar/",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "Tailwind",
          image:
            "https://www.drupal.org/files/project-images/screenshot_361.png",
        },
        {
          name: "Material UI",
          image:
            "data:image/png;base64,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",
        },
      ],
    },
    {
      title: "Backend",
      skills: [
        
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },       
      ],
    },
    {
      title: "Android",
      skills: [
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/2048px-Git_icon.svg.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        
        {
          name: "Figma",
          image:
            "https://w7.pngwing.com/pngs/431/965/png-transparent-figma-designer-computer-icons-material-design-design-rectangle-poster-logo.png",
        },
        {
          name: "ClickUp",
          image:
            "https://clickup.com/images/for-se-page/clickup.png",
        },
      ],
    },
  ];
   
  export const education = [
    {
      id: 0,
      img: pcps,
      school: "Patan College for Professional Studies",
      date: "Jan 2023-Apr 2026",
      // grade: "In Progress",
      desc: "I am currently pursuing a Bachelor's degree in Computer Science and Software Engineering from PCPS College, affiliated with the University of Bedfordshire."
      ,
    },
    {
      id: 1,
      img: kmc,
      school: "Kathmandu Model Secondary School",
      date: "Oct 2020-Sep 2022",
      // grade: "2.74",
      desc: "I have completed my 12th-grade education from Kathmandu Model Secondary School.",
      degree: "SLC ",
    },
    {
      id: 2,
      img: bagmati,
      school: "Bagmati Boarding Secondary School",
      date: "Apr 2018-Aug 2020",
      // grade: "3.80",
      desc: "I have completed my 10th-grade education from Bagmati Boarding Higher Secondary School.",
      degree: "SEE",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "Hotel Management System",
      date: "10 Apr 2023 - 30 Apr 2023",
      description:
      "Introducing our Hotel Booking System, a sophisticated solution tailored to streamline reservations and elevate guest experiences. With its intuitive interface, manage bookings seamlessly while providing guests with a hassle-free booking experience.",
      image: HMS,
      tags: [
        "Java", "JFrame",
        "MySQL", 
      ],
      category: "web app",
      github: "https://github.com/Aanik-2003/Hotel-Management-System",
      webapp: "https://drive.google.com/file/d/1tZzqgJwQUXgIWpdSFUQrNQKqsBXJIrZH/view?usp=sharing",
    },
    {
      id: 1,
      title: "Taxi Booking System",
      date: "25 Nov 2023 - 15 Dec 2023",
      description:
        "Introducing our Taxi Booking System, a cutting-edge platform designed to simplify transportation logistics and enhance passenger convenience. With its user-friendly interface, easily manage bookings while ensuring swift and reliable service for passengers. ",
      image: TBS,
      tags: ["Python", "TKinter", "SQLite",],
      category: "web app",
      github: "https://github.com/Aanik-2003/Taxi-Booking-System",
      webapp: "https://drive.google.com/file/d/1jJfvX4WE5wiMsYgEDvEVeXEIwAjhQ6at/view?usp=sharing",
      
    },
    
    {
      id: 2,
      title: "Facial Recognition",
      date: "Apr 2024",
      description:
      "I have employed various models such as 'CNN', 'AdaBoost', and 'Random Search' to train the facial recognition model.",
      image: FR,
      tags: ["Python", "ANN",],
      category: "machine learning",
      github: "https://github.com/Aanik-2003/Facial-Recognition",
      webapp: "https://drive.google.com/file/d/1QFI8oG4Llw2EFdQdBCL295CjKBTaQP8w/view?usp=sharing",
    },

    {
      id: 3,
      title: "Restaurant Website",
      date: "May 2024",
      description:
      "Introducing our Chinese Dining Hub, an innovative online platform crafted with ReactJS and Tailwind CSS, revolutionizing your culinary experience. Seamlessly browse our extensive menu through our intuitive interface.",
      image: TK,
      tags: ["React", "Tailwind CSS",],
      category: "web development",
      github: "https://github.com/Aanik-2003/restaurant-website",
      webapp: "",
    },
    {
      id: 4,
      title: "Chat App",
      date: "Jun 2024",
      description:
      "It is a real time chat app created using node.js, express, nodemon, react.js, socket.io where users can join rooms as per their interest and can chat in the specific room.",
      image: CA,
      tags: ["React", "Node.js","Socket.io","Nodemon","Express"],
      category: "web app",
      github: "https://github.com/Aanik-2003/chat-app",
      webapp: "",
    },
  ];
  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];